/** @jsxImportSource react */
import { useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, TextField } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { authAPI } from '../../api/auth'
import { storeSession } from '../../store/slices/authSlice'
import { getErrorMessage } from '../../utils/apiErrors'
import { useNotify } from './NotificationProvider'

/** Change password; every other browser is signed out, this one gets a fresh session. */
const ChangePasswordDialog = ({ onClose }) => {
  const notify = useNotify()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [formError, setFormError] = useState(null)
  const change = useMutation({
    mutationFn: () => authAPI.changePassword(current, next),
    onSuccess: (session) => {
      storeSession(session)
      notify('Password changed. Other browsers and devices were signed out.')
      onClose()
    },
  })
  const submit = (e) => {
    e.preventDefault()
    if (next.length < 8) return setFormError('Use at least 8 characters')
    if (next !== confirm) return setFormError('The new passwords don’t match')
    setFormError(null)
    change.mutate()
  }
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ component: 'form', onSubmit: submit }}>
      <DialogTitle>Change password</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>You’ll stay signed in here; everywhere else you’ll need the new password.</DialogContentText>
        <Stack spacing={2}>
          {(formError || change.error) && <Alert severity="error">{formError || getErrorMessage(change.error)}</Alert>}
          <TextField label="Current password" type="password" autoComplete="current-password" required autoFocus value={current} onChange={(e) => setCurrent(e.target.value)} />
          <TextField label="New password" type="password" autoComplete="new-password" required value={next} onChange={(e) => setNext(e.target.value)} helperText="At least 8 characters" />
          <TextField label="Confirm new password" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={change.isPending}>{change.isPending ? 'Changing…' : 'Change password'}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ChangePasswordDialog
